import { ProfileFlags } from '@shared/profile';
import { isFeatureEnabled } from '@luna/gatekeeper';
import type { FLAG } from '@shared/products-types';

export const isJuniorAccount = <T extends Array<unknown> | undefined>(flags: T): boolean => {
    if (!flags) {
        return false;
    }

    return flags.includes(ProfileFlags.JUNIOR);
};

export const hasTopUpFlags = (flags?: FLAG[]): boolean => {
    const hasTopUpAllowedFlag = flags?.includes('topUpAllowed');
    return isJuniorAccount(flags) && !!hasTopUpAllowedFlag;
};

export const isTopUpAllowed = (flags?: FLAG[]): boolean => {
    const isTopUpEnabled = isFeatureEnabled(({ junior }) => junior.newTopUpLogic);
    return hasTopUpFlags(flags) && isTopUpEnabled;
};
